// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .form-control-date {
    width: 100%;
}

.btn-margin {
    margin: 0px 5px;
}

.well {
    border: solid 1px #d3d3d3;
    background-color: #f5f5f5;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.well .row:last-child {
    margin-top: 12px;
    padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/reports/invoice-by-bank-surety/invoice-by-bank-surety.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[":host ::ng-deep .form-control-date {\r\n    width: 100%;\r\n}\r\n\r\n.btn-margin {\r\n    margin: 0px 5px;\r\n}\r\n\r\n.well {\r\n    border: solid 1px #d3d3d3;\r\n    background-color: #f5f5f5;\r\n    padding: 15px 20px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.well .row:last-child {\r\n    margin-top: 12px;\r\n    padding-bottom: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
